import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Customer, Account } from '@inyova/models';

import { select, Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as AppRootActions from '@app/app.actions';
import * as fromAppRoot from '@app/app.reducers';

import { MAXIMUM_3A_CONTRIBUTION } from '@app/app.constants';

@Component({
  selector: 'app-cross-selling',
  templateUrl: 'cross-selling.component.html',
  styleUrls: ['cross-selling.component.scss'],
  standalone: false
})
export class CrossSellingComponent implements OnDestroy, OnInit {
  protected readonly onDestroy$ = new Subject<void>();
  MAXIMUM_3A_CONTRIBUTION = MAXIMUM_3A_CONTRIBUTION;
  customer: Customer;
  currentAccount: Account;
  newAccountKind: string;
  investmentList = [];
  isLoading = false;

  constructor(
    private route: ActivatedRoute,
    private store: Store,
    private router: Router
  ) {
    this.store.pipe(select(fromAppRoot.selectCustomerAndCurrentAccount), takeUntil(this.onDestroy$)).subscribe((value) => {
      this.customer = value.customer;
      this.currentAccount = value.currentAccountDetail;

      if (this.customer.temporary_accounts.length === 0) {
        this.store.dispatch(AppRootActions.toggleCIAccountActive({ show: true }));
      }
    });

    this.store.pipe(select(fromAppRoot.selectCreateNewAccountIsLoading), takeUntil(this.onDestroy$)).subscribe((isLoading) => {
      this.isLoading = isLoading;
    });
  }

  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      this.newAccountKind = params.get('kind') ?? '3b';

      this.investmentList = [
        `crossselling.${this.newAccountKind}.li1`,
        `crossselling.${this.newAccountKind}.li2`,
        `crossselling.${this.newAccountKind}.li3`,
        `crossselling.${this.newAccountKind}.li4`
      ];
    });
  }

  createNewAccount(kind: string): void {
    if (this.isLoading) {
      return;
    }

    const payload = { kind, appLocation: this.customer.app_location };
    // temp hard redirect until account creation is modified
    if (kind === 'grow') {
      void this.router.navigate(['/grow/intro']);
    } else {
      this.store.dispatch(AppRootActions.toggleNewAccountIsLoading({ isLoading: true }));
      this.store.dispatch(AppRootActions.createNewAccount(payload));
    }
  }

  getCurrentYear(): number {
    return new Date().getFullYear();
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
